import {
  AfterViewInit,
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { ColumnConfiguration } from '../../interfaces/column-configuration.interface';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ModalEventosComponent } from 'src/app/pages/dashboards/modals/modal-eventos/modal-eventos.component';
import { WarrantiesService } from 'src/app/pages/dashboards/service/warranties.service';
import { EventLog } from '../../interfaces/tree-node.interface';

@Component({
  selector: 'app-general-table',
  standalone: true,
  imports: [
    CommonModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    CdkMenuModule,
    MatButtonModule,
  ],
  templateUrl: './general-table.component.html',
  styleUrls: ['./general-table.component.scss'],
})
export class GeneralTableComponent implements OnInit, AfterViewInit {
  public tableDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  readonly dialog = inject(MatDialog);
  @Input() columnsConfiguration: ColumnConfiguration[];
  @Input() dataSource: any[];
  @Input() noContentMessage: string = 'Sin info';
  @Input() rowEvents: any[];
  public eventLog: EventLog[];

  constructor(private eventLogService: WarrantiesService) {
    this.tableDataSource = new MatTableDataSource([]);
  }
  ngOnInit(): void {
    this.dataSource.map((e) => console.log(e));
    this.setDataSource(this.dataSource);
  }

  ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.paginator;
    this.tableDataSource.sort = this.sort;
  }

  private setDataSource(arrayData: any[]) {
    this.tableDataSource.data = arrayData;
    this.tableDataSource.paginator = this.paginator;
    this.tableDataSource.sort = this.sort;
  }

  getColumns() {
    if (!this.columnsConfiguration) return [];
    const ids = this.columnsConfiguration.map((col) => col.columnId);
    return ids;
  }

  generateUrl(
    urlTemplate: string,
    params: { [key: string]: string },
    row: any
  ): string {
    let url = urlTemplate;
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        url = url.replace(`{${key}}`, row[params[key]]);
      }
    }
    return url;
  }

  abrirEvento(warrantyId: number) {
    const dialogRef = this.dialog.open(ModalEventosComponent, {
      data: warrantyId,
    });
  }
}
